export const testAttributes = {
    PRIMARY_CTA_BUTTON: 'primary_cta_button',
    PRIMARY_CTA_BUTTON_ICON: 'primary_cta_button_icon',
};

export const classNames = {
    ...testAttributes
};

export const defaultAttributes = {
    color: 'green',
    style: 'filled',
};
